module.exports = __webpack_public_path__ + "static/img/icon_recycle_way_title.bf10be1.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_recycle_way_title.png
// module id = mo5t
// module chunks = 1